// export const hasToken = ({
//     token
// }) => !!token

export const hasToken = (state) => {
    return (state.token != '' ? true : false)
}
export const isMember = (state) => {
    return (state.isMember)
}

// export default {
//     hasToken: state => {
//         return state.token;
//     }
// }